import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { ListingReviewsSectionProvider } from "./ListingReviewsSectionProvider";
import { ListingReviewsSectionWrapper } from "./ListingReviewsSectionWrapper";
import { ListingReviewsSectionHeader } from "./ListingReviewsSectionHeader";
import { ListingReviewsSectionHeaderContainer } from "./ListingReviewsSectionHeaderContainer";
import { ListingReviewsTitleStarWrapper } from "./ListingReviewsTitleStarWrapper";
import { BodyMedium, TitleLarge } from "../../../global/ui/typography";
import { ListingScoreStarRating } from "./ListingScoreStarRating";
import { ListingReviewsLoadMore } from "./ListingReviewsLoadMore";
import { ListingReviewsGrid } from "./ListingReviewsGrid";
import { ListingReviewsGridContent } from "./ListingReviewsGridContent";

export const ListingReviewsSection = () => {
  const listingRedux = useSelector(
    (state: RootState) => state.trainingPlan.listingData,
  );
  const reviewsRedux = useSelector(
    (state: RootState) => state.trainingPlan.reviews,
  );

  if (reviewsRedux.length > 0) {
    return (
      <ListingReviewsSectionProvider>
        <ListingReviewsSectionWrapper>
          <ListingReviewsSectionHeader>
            <ListingReviewsSectionHeaderContainer>
              <ListingReviewsTitleStarWrapper>
                <TitleLarge>Reviews</TitleLarge>
                <ListingScoreStarRating />
              </ListingReviewsTitleStarWrapper>
              <BodyMedium>{listingRedux.reviews} Reviews</BodyMedium>
            </ListingReviewsSectionHeaderContainer>

            <ListingReviewsLoadMore className={"hidden lg:flex"} />
          </ListingReviewsSectionHeader>

          <ListingReviewsGrid>
            <ListingReviewsGridContent />
          </ListingReviewsGrid>
          <ListingReviewsLoadMore className={"flex lg:hidden mx-auto"} />
        </ListingReviewsSectionWrapper>
      </ListingReviewsSectionProvider>
    );
  }
};
